import hoistNonReactStatics from 'hoist-non-react-statics'
import { shape } from 'prop-types'

import MountPointsClass from 'shared/utils/mountPoints'
import { publicRuntimeConfigType } from 'views/utils/propTypes'

import withShopAndRuntimeConfig from './withShopAndRuntimeConfig'

const withMountPoints = Component => {
  const ComposedComponent = props => {
    const {
      publicRuntimeConfig: {
        publicConfig: { mountPoints, tenant, language },
        pageProperties: {
          coreShopEnvironment,
          experiments,
          nx,
          featureToggles,
        },
      },
    } = props
    const mountPointsInstance = new MountPointsClass({
      mountPoints,
      tenant,
      language,
      coreShopEnvironment,
      experiments,
      nx,
      featureToggles,
    })

    return <Component {...props} mountPoints={mountPointsInstance} />
  }

  ComposedComponent.propTypes = {
    publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  }

  // added here because of returning default props in views/containers/esi/SidebarNavigation in catch block
  ComposedComponent.defaultProps = {
    ...Component.defaultProps,
  }

  hoistNonReactStatics(ComposedComponent, Component)

  return withShopAndRuntimeConfig(ComposedComponent)
}

export default withMountPoints
